<template>
  <div class="p-6 space-y-4 animate-fade-in">
    <h2 class="text-white text-xl font-semibold">Import Equipment CSV</h2>
    <div class="glass rounded-xl p-4 space-y-3 max-w-2xl">
      <a
        :href="templateHref"
        download="equipment_template.csv"
        class="px-3 py-2 rounded btn-primary inline-block"
        >Download Template</a
      >
      <input type="file" accept=".csv" @change="onFile" class="block text-slate-300" />
      <p v-if="message" class="text-slate-400">{{ message }}</p>
      <p v-if="error" class="text-red-400">{{ error }}</p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { supabase } from '@/lib/supabaseClient'

const message = ref('')
const error = ref('')
const template =
  'Category,Make,Model,Descriptor,Name,Serial\nPOTS Alternative,Arris,eMTA,24 (8 ports x 3 eMTAs),Arris eMTA 24,e.g. SER123\n'
const templateHref = 'data:text/csv;charset=utf-8,' + encodeURIComponent(template)

async function onFile(e: Event) {
  message.value = ''
  error.value = ''
  const input = e.target as HTMLInputElement
  const file = input.files?.[0]
  if (!file) return
  const text = await file.text()
  const rows = text.split(/\r?\n/).filter(Boolean)
  const header =
    rows
      .shift()
      ?.split(',')
      .map((s) => s.trim().toLowerCase()) || []
  const idx = (k: string) => header.indexOf(k)
  const out: any[] = []
  for (const line of rows) {
    const cols = line.split(',')
    const category = cols[idx('category')]?.trim()
    const make = cols[idx('make')]?.trim()
    const model = cols[idx('model')]?.trim()
    const descriptor = cols[idx('descriptor')]?.trim()
    const name = cols[idx('name')]?.trim()
    const serial = cols[idx('serial')]?.trim()
    if (!category || !name) continue
    // map category to id
    const { data: cat } = await supabase
      .schema('app' as any).from('categories')
      .select('id')
      .eq('name', category)
      .maybeSingle()
    out.push({
      name,
      serial: serial || null,
      make,
      model,
      descriptor,
      category_id: cat?.id || null,
    })
  }
  if (!out.length) {
    error.value = 'No valid rows'
    return
  }
  const { error: e1 } = await supabase.schema('app' as any).from('equipment').insert(out)
  if (e1) {
    error.value = e1.message
  } else {
    message.value = `Imported ${out.length} rows`
  }
}
</script>
